import {
  EntityServiceTransaction, HistoryActivity, InformationServiceTransaction, JobRunning,
  ServiceTransaction,
  ServiceTransactionInitState
} from '@/store/service-transaction/service-transaction.types';
import {ServiceTransactionAction} from '@/store/service-transaction/service-transaction.actions';
import {ServiceTransactionMutations} from '@/store/service-transaction/service-transaction.mutations';

const namespaced = true;

export const serviceTransactionInitState: ServiceTransactionInitState = {
  serviceTransactions: [{}] as EntityServiceTransaction[],
  serviceTransactionHistory: [{}] as EntityServiceTransaction[],
  serviceTransaction: {} as EntityServiceTransaction,
  information: {} as InformationServiceTransaction,
  rating: 0,
  jobIsRunning: false,
  jobRunning: {} as JobRunning,
  service: {} as EntityServiceTransaction,
  inviteReceiver: [{}] as EntityServiceTransaction[],
  inviteProvider: [{}] as EntityServiceTransaction[],
  historyActivity: [{}] as HistoryActivity[]
};

export const serviceTransactionState = {
  namespaced,
  state: serviceTransactionInitState,
  actions: ServiceTransactionAction,
  mutations: ServiceTransactionMutations,
  // getters
};
